import { Meta, Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { BannerServiceService } from '../services/banner-service.service';
import {environment as env} from '../../environments/environment';
import {LanguageService} from '../services/language.service';

declare var $: any;


@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  homePageSliderList = [];
  homepageBestSeelerList = [];
  showLang:string;
  imgurl:string; 
 
  constructor(public bannerService:BannerServiceService, private langObj:LanguageService, private title: Title,private meta: Meta) {
    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });
  }


  scrollToElement($element): void {
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  ngOnInit(): void {

    this.title.setTitle('Best Arabic Restaurant in Abu Dhabi UAE | Sajway');
    this.meta.updateTag({ name: 'description', content: 'Best Arabic Restaurant in Abu Dhabi UAE provides mouth-watering food. One of the fantastic things about visiting Abu Dhabi is the popular choice of top quality places to dine.' });
    this.meta.updateTag({ name: 'keywords', content: 'Sajway, Best arabic restaurant in abu dhabi, صاجواي, أفضل مطعم عربي في أبو ظبي ' });


    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

    //Home page slider
    this.imgurl =  env.imgurl;
    this.bannerService.getHomeBannerSliderList().subscribe((data:any)=>{
      console.log(data.data);
      this.homePageSliderList = data.data;

      var action = false, clicked = false;
      var Owl = {
      init: function() {
      Owl.carousel();
      },
      carousel: function() {
      var owl;
      $(document).ready(function() {
      owl = $('#mainSlider').owlCarousel({
      items    : 1,
      center     : true, 
      nav        : false,
      dots       : true,
      loop       : true,
      animateOut: 'fadeOut',
      autoplay:true,
      autoplayTimeout:5000,
      slideSpeed: 6000,
      autoplayHoverPause:true,
      dotsContainer: '.test',
      });
      $('.bookmarks').on('click', 'li', function(e) {
      owl.trigger('to.owl.carousel', [$(this).index(), 300]);
      });
      });
      }
      };
      $(document).ready(function() {
      Owl.init();
      });
    });

    //Home page best seller list
    this.bannerService.getHomeBannerBestSellerList().subscribe((data:any)=>{
      console.log(data.data);
      this.homepageBestSeelerList = data.data;
    });
  }

}
